var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkspaceTemporalLearners(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 1.468a4.5 4.5 0 010 8.064m2 5.234c1.512.684 2.872 1.799 4 3.234M1 18c1.946-2.477 4.59-4 7.5-4s5.553 1.523 7.5 4M13 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z",
    stroke: "#24292E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgWorkspaceTemporalLearners;